import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import * as _ from "./lodash";
import React from 'react';
export default function cloneChildrenWithDefaultProps(props, propWhitelist) {
  var defaultProps = propWhitelist !== undefined ? _.pick(props, propWhitelist) : props;
  var childProps;
  var children = React.Children.toArray(props.children);
  return _mapInstanceProperty(_).call(_, children, function (child, index) {
    childProps = _.assign({}, defaultProps, child.props);
    return /*#__PURE__*/React.cloneElement(child, childProps);
  });
}
//# sourceMappingURL=clone-children-with-default-props.js.map